module.exports = "query Voucher ($id: String!) {\n  voucher (id: $id) {\n    id\n    code\n    expires: expire_date\n    created: created_at\n\n    company_user\n    campaign {\n      title\n      value\n      symbol\n      important\n\n      partner {\n        logo\n        name\n\n        contact {\n          phone\n        }\n      }\n    }\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/Voucher.graphql
// module id = 2002
// module chunks = 1612